import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20artistic%20illustration%20with%20soft%20warm%20orange%20and%20cream%20gradient%20background%2C%20abstract%20comic%20panel%20elements%20floating%2C%20minimalist%20design%20with%20subtle%20texture%2C%20clean%20aesthetic%2C%20warm%20atmosphere%2C%20modern%20illustration%20style&width=1920&height=900&seq=hero-bg-01&orientation=landscape"
          alt="韩漫网背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center pt-20 pb-16">
          <p className="text-sm text-primary-300 font-medium tracking-widest mb-4">
            KOREAN MANHWA ONLINE
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 leading-tight">
            韩国漫画全集免费
            <br />
            下拉式在线阅读
          </h1>
          <p className="mt-6 text-base md:text-lg text-background-50/80 max-w-2xl mx-auto leading-relaxed">
            汇集全网最全韩国漫画资源，支持流畅下拉式阅读体验。
            恋爱、动作、奇幻、悬疑 —— 随时随地畅读热门韩漫大全，享受无缝阅读乐趣。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/action"
              className="px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer flex items-center gap-2"
            >
              立即阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 border border-background-50/30 text-background-50 text-sm font-medium rounded-full whitespace-nowrap hover:bg-background-50/10 transition-all duration-300 cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {[
              { value: '2,000+', label: '漫画资源' },
              { value: '50万+', label: '日活跃读者' },
              { value: '每日更新', label: '更新频率' },
              { value: '完全免费', label: '阅读模式' },
            ].map((stat) => (
              <div
                key={stat.label}
                className="bg-background-50/10 backdrop-blur-sm rounded-lg px-4 py-3 border border-background-50/10"
              >
                <p className="text-xl md:text-2xl font-bold text-background-50 whitespace-nowrap">
                  {stat.value}
                </p>
                <p className="text-xs text-background-50/60 mt-1 whitespace-nowrap">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}